export default __webpack_public_path__ + "static/media/2019.b8d50ac2.mp3";